import React from "react";
import { MailIcon, Phone } from "lucide-react";
import IconLabel from "./IconLabel";
import { Link } from "react-router-dom";

// Default link sections
const DEFAULT_LINK_SECTIONS = [
  {
    title: "Cases",
    links: [
      { text: "Barkfors", href: "/case-study/9" },
      { text: "Campaigns Never Die", href: "/case-study/5" },
      { text: "Pathbeat", href: "/case-study/6" },
      { text: "Clinvvo", href: "/case-study/8" },
    ],
  },
  {
    title: "Company",
    links: [
      { text: "About Us", href: "/about" },
      { text: "Careers", href: "/careers" },
      { text: "Contact Us", href: "/contact" },
    ],
  },
];

const Footer = ({ linkSections = DEFAULT_LINK_SECTIONS, className = "" }) => {
  return (
    <footer>
      <div
        className={`flex flex-row mt-[40%] md:mt-[2%] mb-[2%] px-4 md:px-20 ${className}`}
      >
        <div className="flex-1 flex relative">
          <div className="text-white flex-1 items-start flex flex-col md:flex-row space-y-5 md:space-y-0 md:space-x-5">
            <div className="self-start md:self-auto">
              <a href="/">
                <img
                  className="h-[32px] md:h-[44px] mb-2"
                  src="/datapixl-small.png"
                  alt="DataPixl"
                ></img>
              </a>
              <h1 className="text-base md:text-xl text-mid-grey-color font-medium drop-shadow-lg leading-normal tracking-normal pb-4">
                Beyond Algorithms,
                <br />
                Towards Impact
              </h1>
              <div className="space-y-2">
                <IconLabel
                  icon={<MailIcon size={18} />}
                  href="mailto:contact@datapixl.ai"
                  label="contact@datapixl.ai"
                />
                <IconLabel
                  icon={<Phone size={18} />}
                  label="+91 9353636917"
                  href="tel:+919353636917"
                />
                <IconLabel
                  icon={<Phone size={18} />}
                  label="+46 725074872"
                  href="tel:+46725074872"
                />
              </div>
            </div>

            <div className="flex-grow"></div>
            <div className="flex flex-col md:flex-row space-y-14 md:space-y-0 md:space-x-32">
              {linkSections.map((section, sectionIndex) => (
                <div key={`section-${sectionIndex}`} className="flex flex-col">
                  <h2 className="text-base font-bold leading-normal tracking-normal pb-3">
                    {section.title}
                  </h2>
                  <ul className="space-y-2 cursor-pointer">
                    {section.links.map((link) => (
                      <li key={link.href}>
                        <Link
                          to={link.href}
                          className="hover:text-link-hovered text-link-unhover transition-colors font-medium text-[14px] md:text-[16px] leading-[140%] tracking-[0] relative group cursor-pointer"
                        >
                          {link.text}
                          {/* Underline Animation */}

                          <span
                            className="absolute left-0 bottom-[-4px] w-full h-[2px] bg-white origin-left 
                           scale-x-0 transition-transform duration-300 ease-in-out group-hover:scale-x-100"
                          ></span>
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      <img className="w-full" src="/datapixl-bottom.png" alt="DataPixl"></img>
    </footer>
  );
};

export default Footer;
